import { render } from "./Save.vue?vue&type=template&id=a55b147a&scoped=true"
import script from "./Save.vue?vue&type=script&lang=js"
export * from "./Save.vue?vue&type=script&lang=js"

import "./Save.vue?vue&type=style&index=0&id=a55b147a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a55b147a"]])

export default __exports__